export interface AuditLogEntry {
  id: string;
  tenant_id: string;
  entity_type: string;
  entity_id: string;
  action: string;
  actor_login: string | null;
  old_values: Record<string, unknown> | null;
  new_values: Record<string, unknown> | null;
  created_at: string;
}

export interface AuditLogListResponse {
  items: AuditLogEntry[];
  total: number;
  limit: number;
  offset: number;
}

export const ENTITY_TYPE_LABELS: Record<string, string> = {
  guest: "Gast",
  pitch: "Stellplatz",
  pitch_category: "Platzkategorie",
  booking: "Buchung",
  invoice: "Rechnung",
  payment: "Zahlung",
  article: "Artikel",
  article_price: "Artikelpreis",
  article_category: "Artikelkategorie",
  article_batch: "Artikelcharge",
  charge_rule: "Buchungszuordnung",
  visitor_registration: "Besucheranmeldung",
  discount: "Rabatt",
  account: "Erlöskonto",
  contract: "Vertrag",
  support_ticket: "Ticket",
};

export const ACTION_LABELS: Record<string, string> = {
  created: "Angelegt",
  updated: "Geändert",
  seeded: "Standard angelegt",
  imported: "Aus Kontenrahmen importiert",
  checked_in: "Eingecheckt",
  checked_out: "Ausgecheckt",
  issued: "Ausgestellt",
  cancelled: "Storniert",
  recorded: "Erfasst",
  payment_recorded: "Zahlung verbucht",
  email_sent: "E-Mail gesendet",
  commented: "Kommentiert",
  pitch_unfixed: "Platzfixierung aufgehoben",
  pitch_fixed_changed: "Fixierten Platz geändert",
  privacy_erased: "Datenschutz-Löschung",
};
